// projectMeta.js
export const projectMeta = [
  {
    id: 1,
    title: "Website",
    path: "/Projects/Website",
    file: "Website.js",
    description: "The history of my personal website, from a simple HTML page to a React.js application.",
    points: ["Used React.js to create a personalized portfolio website.",
      "Learned to make my own components and manage state effectively.",
      "Learned how to deploy and host a React application on my server."],
    image: "/projectImages/Web/OldSite.png",
    tags: ["React", "Web"],
    date: "Jun 2021",
  },
  {
    id: 2,
    title: "VR Experiences",
    path: "/Projects/VR",
    file: "VR.js",
    description: "A collection of my virtual reality commissions and personal projects, showcasing immersive environments and interactive elements.",
    points: ["Worked with clients to create custom VR experiences using Unity and C# for the VRChat platform.",
      "Developed skills in 3D modeling, texturing, and optimizing assets for VR performance.",
      "Implemented interactive features and user interfaces to enhance the VR experience.",
      "Created my own Authentication system for VRChat worlds to manage user access and permissions."],
    image: "/projectImages/VR/Cave.png",
    tags: ["GameDev", "Csharp"],
    date: "Sep 2023 - Present",
  }
  // {
  //   id: 3,
  //   title: "Server Restructuring",
  //   path: "/Projects/ServerRestructing",
  //   file: "SRestructure.js",
  //   description: "Restructuring of my home server to improve performance, security, and manageability using Docker and Portainer.",
  //   points: ["Created a new server architecture using Docker and Portainer to manage containers and services.",
  //     "Separated services into individual containers for better isolation and maintainability.",
  //     "Used Cloudflare Zero Trust to secure access to management interfaces and services.",
  //     "Added another vpn for backup and redundancy, ensuring continuous access to the server even if one VPN fails."],
  //   image: "/projectImages/Server/Servers.png",
  //   tags: ["Server", "Networking, Docker, Compose, Portainer"],
  //   date: "July 2026",
  // }
];
